import moment from "moment";

const hollidays = [
  moment("2021-12-31"),
  moment("2022-01-17"),
  moment("2022-02-21"),
  moment("2022-05-30"),
  moment("2022-06-20"),
  moment("2022-07-4"),
  moment("2022-09-5"),
  moment("2022-10-10"),
  moment("2022-11-11"),
  moment("2022-11-24"),
  moment("2022-12-26"),
  moment("2023-01-2"),
  moment("2023-01-16"),
  moment("2023-02-20"),
  moment("2023-05-29"),
  moment("2023-06-19"),
  moment("2023-07-4"),
  moment("2023-09-4"),
  moment("2023-10-9"),
  moment("2023-11-10"),
  moment("2023-11-23"),
  moment("2023-12-25"),
];

export default hollidays;
